module.exports = __webpack_public_path__ + "media/images/official/guide_image2-d668880b75de60f8a6af58dc09fd4c26.svg";